import React from "react";
import { BACKUP_PLAN_SETTINGS } from "./../../../../componentsConfig";

function BackupPlanSettings(props) {
  const [currentPanel, setCurrentPanel] = React.useState({
    name: "summary",
    type: "",
    params: {}
  });

  const switchPanelHandler = React.useCallback((name, type, params) => {
    setCurrentPanel({ name: name, type: type, params: params });
  }, []);

  return (
    <React.Fragment>
      {React.createElement(BACKUP_PLAN_SETTINGS[currentPanel.name].component, {
        switchPanel: switchPanelHandler,
        currentPanel
      })}
    </React.Fragment>
  );
}

export default BackupPlanSettings;
